import { Children, cloneElement } from 'react';

import type { FC, ReactElement } from 'react';

export interface MapperProps {
  items: Array<{ id: string }>;
  children: ReactElement;
}

export const Mapper: FC<MapperProps> = ({ items = [], children }) => {
  if (!Array.isArray(items)) return null;
  const Child = Children.only(children);

  return <>{items.map((item) => cloneElement(Child, item))}</>;
};
